import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { Form, OverlayTrigger, Tooltip, FloatingLabel } from 'react-bootstrap';
import { IC_INFO_BLUE } from '../../../Assets/images';
import InputFieldStyled from './InputFieldStyled';

const InputFieldControl = ({
  children,
  customClass,
  disabled,
  errorMessage,
  isInvalid,
  isLabel,
  isTextArea,
  label,
  labelTooltip,
  maxLength,
  minLength,
  name,
  onBlur,
  onChange,
  onClick,
  placeholder,
  readOnly,
  refTest,
  required,
  rows,
  subLabel,
  textType: initialTextType,
  valueType,
  isFloatingLabel = true
}) => {
  const formGroupRef = useRef(null);
  const [textBoxType, setTextBoxType] = useState(initialTextType)

  const renderLabel = () => {
    if (!isLabel) {
      return null;
    }

    return (
      <Form.Label className={readOnly ? 'readOnly' : ''}>
        {label} {subLabel && <span className="subText">{subLabel}</span>}
        {labelTooltip && (
          <OverlayTrigger
            placement="top-start"
            container={formGroupRef}
            overlay={
              <Tooltip id="button-tooltip-2">
                <strong>Name and mobile # of person</strong> receiving the shipment at this address
              </Tooltip>
            }
          >
            <div className="info">
              <Image className="img" src={IC_INFO_BLUE.src} alt="" layout="fill" />
            </div>
          </OverlayTrigger>
        )}
      </Form.Label>
    );
  };

  return (
    <InputFieldStyled className={customClass}>
      <Form.Group className="d-flex flex-column" ref={formGroupRef}>
        {isFloatingLabel && (
          <FloatingLabel controlId={name} label={renderLabel()}>
            <Form.Control
              ref={refTest}
              disabled={disabled}
              name={name}
              as={isTextArea ? 'textarea' : undefined}
              type={!isTextArea ? textBoxType : undefined}
              placeholder={placeholder}
              className={isTextArea ? 'textarea' : 'inputField'}
              value={valueType}
              readOnly={readOnly}
              plaintext={readOnly}
              onChange={onChange}
              onClick={onClick}
              required={required}
              maxLength={maxLength}
              minLength={minLength}
              isInvalid={isInvalid}
              isLabel={isLabel}
              labelTooltip={labelTooltip}
              onBlur={onBlur}
              rows={rows}
            />
            {initialTextType === 'password' && (
              <span
                className={textBoxType === 'password' ? 'password_icon hide_eye_img' : 'password_icon show_eye_img'}
                onClick={() => {
                  if (textBoxType === 'password') {
                    setTextBoxType('text');
                  } else {
                    setTextBoxType('password');
                  }
                }}
              ></span>
            )}
            <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>
          </FloatingLabel>
        )}
        {!isFloatingLabel && (
          <Form.Label htmlFor={name}>
            <Form.Control
              ref={refTest}
              disabled={disabled}
              name={name}
              as={isTextArea ? 'textarea' : undefined}
              type={!isTextArea ? textBoxType : undefined}
              placeholder={placeholder}
              className={isTextArea ? 'textarea' : 'inputField'}
              value={valueType}
              readOnly={readOnly}
              plaintext={readOnly}
              onChange={onChange}
              onClick={onClick}
              required={required}
              maxLength={maxLength}
              minLength={minLength}
              isInvalid={isInvalid}
              isLabel={isLabel}
              labelTooltip={labelTooltip}
              onBlur={onBlur}
              rows={rows}
            />
            {initialTextType === 'password' && (
              <span
                className={textBoxType === 'password' ? 'password_icon hide_eye_img' : 'password_icon show_eye_img'}
                onClick={() => {
                  if (textBoxType === 'password') {
                    setTextBoxType('text');
                  } else {
                    setTextBoxType('password');
                  }
                }}
              ></span>
            )}
            <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>
          </Form.Label>
        )}
      </Form.Group>
      {children}
    </InputFieldStyled>
  );
};

InputFieldControl.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  subLabel: PropTypes.string,
  placeholder: PropTypes.string,
  textType: PropTypes.string,
  valueType: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  name: PropTypes.string,
  isInvalid: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  isLabel: PropTypes.bool,
  customClass: PropTypes.string,
  rows: PropTypes.number,
  isTextArea: PropTypes.bool,
  disabled: PropTypes.bool,
  labelTooltip: PropTypes.bool,
  refTest: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.object })]),
  onBlur: PropTypes.func,
};

InputFieldControl.defaultProps = {
  customClass: '',
  readOnly: false,
  isLabel: false,
  isTextArea: false,
  rows: 3,
  disabled: false,
  labelTooltip: false,
  refTest: null,
  onBlur: () => {},
  children: null,
  label: '',
  subLabel: '',
  placeholder: '',
  textType: 'text',
  valueType: '',
  required: false,
  errorMessage: '',
  maxLength: 100,
  minLength: 0,
  name: '',
  isInvalid: false,
  onChange: () => { },
  onClick: () => { },
};

export default InputFieldControl;
